import { render, staticRenderFns } from "./ProductManageModal.vue?vue&type=template&id=4d472bcd&"
import script from "./ProductManageModal.vue?vue&type=script&lang=js&"
export * from "./ProductManageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports